import { AdminStats, Channel, Company, CompanyStats, FeatureFlag, MetaTemplate, Queue, User } from 'adminPanel/types';
import api from 'services/api';

export const getCompanies = (): Promise<Company[]> => {
    return api.get('/companies/list').then(({ data }) => data);
};

export const getCompany = (companyId: number): Promise<Company> => {
    return api.get(`/companies/${companyId}`).then(({ data }) => data);
};
export const getCompanyUsers = (companyId: number): Promise<User[]> => {
    return api
        .get(`/admin/companies/${companyId}/users`)
        .then(({ data }) => data);
};
export const getCompanyQueues = (companyId: number): Promise<Queue[]> => {
    return api.get(`/queue?companyId=${companyId}`).then(({ data }) => data);
};
export const getCompanyChannels = (companyId: number): Promise<Channel[]> => {
    return api.get(`/whatsapp/company/${companyId}`).then(({ data }) => data);
};
export const getCompanyFeatureFlags = (
    companyId: number
): Promise<FeatureFlag[]> => {
    return api
        .get(`/companyFeatures/${companyId}`)
        .then(({ data }) =>
            data.map((item: { feature: FeatureFlag }) => item.feature)
        );
};

export const assignFeatureFlag = (
    companyId: number,
    featureId: number
): Promise<FeatureFlag[]> => {
    return api.post(`/companyFeatures`, { featureId, companyId });
};

export const deleteFeatureFlag = (
    companyId: number,
    featureId: number
): Promise<FeatureFlag[]> => {
    return api.delete(`/companyFeatures`, { data: { featureId, companyId } });
};

export const updateCompany = (
    companyId: number,
    data: Partial<Pick<Company, 'status' | 'dueDate'>>
): Promise<Company> => {
    return api.put(`/companies/${companyId}`, data).then(({ data }) => data);
};

export const disconnectAllCompanyUsers = (
    companyId: number
): Promise<Company> => {
    return api
        .get(`/companies/disconnectAll/${companyId}`)
        .then(({ data }) => data);
};

export const getAdminStats = (): Promise<AdminStats> => {
    return api.get('/admin/stats').then(({ data }) => data);
};

export const getCompanyStats = (companyId: number): Promise<CompanyStats> => {
    return api.get(`/admin/companies/${companyId}/stats`).then(({ data }) => data);
};

export const getCompanyTemplates = (
    companyId: number,
    whatsappId?: number,
    cursor?: string
): Promise<{ data: MetaTemplate[]; paging?: { cursors?: { after?: string } } }> => {
    const params = new URLSearchParams();
    if (whatsappId) params.set('whatsappId', String(whatsappId));
    if (cursor) params.set('cursor', cursor);
    return api
        .get(`/admin/companies/${companyId}/templates?${params.toString()}`)
        .then(({ data }) => data);
};

export const getCompanyPhoneQuality = (
    companyId: number,
    whatsappId: number
): Promise<{ quality_rating: string }> => {
    return api
        .get(`/admin/companies/${companyId}/phoneQuality?whatsappId=${whatsappId}`)
        .then(({ data }) => data);
};

export type WhatsappLog = {
    id: number;
    whatsappId: number;
    companyId: number;
    type: 'CONNECTED' | 'DISCONNECTED' | 'RECONNECTING' | 'QR_GENERATED' | 'QR_EXPIRED' | 'ERROR';
    reason: string | null;
    statusCode: number | null;
    createdAt: string;
    updatedAt: string;
};

export const getChannelLogs = (
    companyId: number,
    whatsappId: number
): Promise<WhatsappLog[]> => {
    return api
        .get(`/admin/companies/${companyId}/channels/${whatsappId}/logs`)
        .then(({ data }) => data);
};
